import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  pmDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './generate-document-dialog.controller';
import template from './generate-document-dialog.html';

// Validation
import documentGenerateDocumentMessagesTpl from './generate-document.messages.html';


class dialogService {
  getOptions($event, { document, settings }) {
    return {
      controller,
      controllerAs: 'generateDocumentDialogVM',
      locals: {
        document,
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.generateDocumentDialog', [
  constants,
  ngCookies,
  pmDataService,
  reportsDataService,
  ssDialogService,
  loaderService,
  alerts,
])
  .service('generateDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('generate-document.messages.html', documentGenerateDocumentMessagesTpl);
  })
  .name;
